import type { Theme } from '@mui/material';

export const styles = {
  tableHead: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[50],
  }),

  tableContainer: (theme: Theme) => ({
    width: '100%',
    boxShadow: '0px 4px 23px 0px #00000014',
    border: '1px solid',
    borderColor: theme.colors.neutral[100],
  }),

  loadingCell: {
    textJustify: 'center',
    textAlign: 'center',
    p: 0,
    height: 48,
  },
};
